import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4l0 16","key":"svg-0"}],["path",{"d":"M4 11a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -2","key":"svg-1"}]]

const IconLayoutAlignRight = createReactComponent('outline', 'layout-align-right', 'LayoutAlignRight', __iconNode);

export default IconLayoutAlignRight;